export function categoryKey(category) {
  return (category || "").trim();
}

export function categoryLabel(category) {
  const key = categoryKey(category);
  return key || "未分类";
}

export function groupQuestions(questions) {
  const groups = {};
  (questions || []).forEach((question) => {
    const key = categoryKey(question.category);
    if (!groups[key]) {
      groups[key] = [];
    }
    groups[key].push(question);
  });
  return groups;
}

export function categorySize(questions, category) {
  const groups = groupQuestions(questions);
  return (groups[categoryKey(category)] || []).length;
}

export function syncDrawRules(questions, drawRules) {
  const groups = groupQuestions(questions);
  const previous = {};
  (drawRules || []).forEach((rule) => {
    previous[categoryKey(rule.category)] = rule.count;
  });
  return Object.keys(groups).map((key) => {
    const total = groups[key].length;
    let count = previous[key];
    if (count === undefined || count === null || count === "") {
      count = total;
    }
    count = Number(count);
    if (Number.isNaN(count) || count < 0) {
      count = 0;
    }
    if (count > total) {
      count = total;
    }
    return { category: key, count };
  });
}

export function hasPartialDraw(questions, drawRules) {
  return (drawRules || []).some((rule) => Number(rule.count) < categorySize(questions, rule.category));
}

export function paperQuestionCount(exam) {
  const questions = (exam && exam.questions) || [];
  const rules = exam && exam.drawRules;
  if (!rules || !rules.length || !hasPartialDraw(questions, rules)) {
    return questions.length;
  }
  return rules.reduce((sum, rule) => sum + (Number(rule.count) || 0), 0);
}

export function paperTotalScore(questions, drawRules) {
  const list = questions || [];
  if (!drawRules || !drawRules.length || !hasPartialDraw(list, drawRules)) {
    return list.reduce((sum, question) => sum + (Number(question.score) || 0), 0);
  }
  const groups = groupQuestions(list);
  return drawRules.reduce((sum, rule) => {
    const pool = groups[categoryKey(rule.category)] || [];
    const count = Number(rule.count) || 0;
    if (!pool.length || count <= 0) {
      return sum;
    }
    if (count >= pool.length) {
      return sum + pool.reduce((score, question) => score + (Number(question.score) || 0), 0);
    }
    return sum + (Number(pool[0].score) || 0) * count;
  }, 0);
}

export function findMixedScoreCategory(questions, drawRules) {
  const groups = groupQuestions(questions);
  const rule = (drawRules || []).find((item) => {
    const pool = groups[categoryKey(item.category)] || [];
    const count = Number(item.count) || 0;
    if (count <= 0 || count >= pool.length) {
      return false;
    }
    const score = Number(pool[0].score);
    return pool.some((question) => Number(question.score) !== score);
  });
  return rule ? categoryLabel(rule.category) : "";
}
